<div
  class="ontario-checkboxes__item"
  [class.ontario-checkboxes__item--error]="error"
  [class.ontario-checkboxes__item--compact]="compact"
  [class.ontario-checkboxes__item--preview]="preview && !checked"
>
  <input
    class="ontario-checkboxes__input"
    type="checkbox"
    [id]="checkboxId"
    [checked]="checked"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    (change)="onToggle($event)"
  />
  <label class="ontario-checkboxes__label" [attr.for]="checkboxId">
    <ng-content></ng-content>
  </label>
</div>
